import Header from "./components/header/Header";
import React, {useEffect, useState} from "react";
import Sidebar from "./components/Sidebar";

const Layout = ({children, sidebarClickHandler, userInfo}) => {
  const [isOpen, setIsOpen] = useState(false);


  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth >= 950); // Check screen width and set isOpen accordingly
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="flex flex-row w-full h-screen">
      <Sidebar
        onClick={sidebarClickHandler}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        userInfo={userInfo}
        className={`${isOpen ? 'w-96' : 'w-0'} z-100 flex h-screen`} // Adjust width here
      />
      {/*absolute sm:static md:static lg:static*/}
      <div className={`flex flex-col w-full overflow-x-auto`}>
        <Header
          isOpen={isOpen}
          onClick={sidebarClickHandler}
          setIsOpen={setIsOpen}
          userInfo={userInfo}
          className="flex flex-row py-4 shadow-2lg sticky w-full"
        />
        <main className="px-2 py-8 h-screen overflow-y-auto bg-gray-100">{children}</main>
      </div>
    </div>

  )
};

export default Layout;
